import { BoundingBox, GeoJsonRoot, Geometry, LeafletAccessor, MapGebietRow } from "./geo-json-types";

export class GeoJsonUtils {
    private MapGebiete: MapGebietRow[] = [];

    public clear() {
        this.MapGebiete = [];
    }

    public addMapGebiet(mapGebiet: MapGebietRow): void {

        if ( !mapGebiet || !mapGebiet.mapGebietGeoJson || typeof(mapGebiet.mapGebietGeoJson) !== "string" ) return
        if ( !mapGebiet.mapGebietGeoJson.startsWith("{")  ) return;

        try {
            mapGebiet.mapGebietGeoJson = JSON.parse(mapGebiet.mapGebietGeoJson);
            this.MapGebiete.push(mapGebiet);
        } catch (error) {
            console.error("Failed to parse GeoJson:", error);
        }
    }

    
    public getMapGebiete(): MapGebietRow[] {
        return this.MapGebiete;
    }


    public getRevier(): MapGebietRow | undefined {
        if( !this.MapGebiete || this.MapGebiete.length === 0 ) return undefined;
        return this.MapGebiete[0]
    }




   public getBoundingBox(row: MapGebietRow): BoundingBox | undefined {
        if (
            !row.boundingBoxSouthWestLat ||
            !row.boundingBoxSouthWestLong ||
            !row.boundingBoxNorthEastLat ||
            !row.boundingBoxNorthEastLong
        ) {
            return undefined;
        }
        const minLat = parseFloat(row.boundingBoxSouthWestLat);
        const minLng = parseFloat(row.boundingBoxSouthWestLong);
        const maxLat = parseFloat(row.boundingBoxNorthEastLat);
        const maxLng = parseFloat(row.boundingBoxNorthEastLong);

        if (
            isNaN(minLat) || isNaN(minLng) ||
            isNaN(maxLat) || isNaN(maxLng)
        ) {
            return undefined;
        }

        return [[minLat, minLng], [maxLat, maxLng]];
    }

    public getFirstCoordinateArrayFromGeoJson(geoJson: GeoJsonRoot): number[][] | undefined {
        if (!geoJson.features || geoJson.features.length === 0) return undefined;
        const geometry = geoJson.features[0].geometry;
        if (!geometry || !geometry.coordinates) return undefined;

        switch (geometry.type) {
            case "MultiPolygon":
                return geometry.coordinates[0]?.[0];
            case "Polygon":
            case "MultiLineString":
                return geometry.coordinates[0];
            case "LineString":
                return geometry.coordinates as number[][];
            default:
                return undefined;
        }
    }

}


// export class GeoJsonRenderer {
//     constructor(private leafletAccessor: LeafletAccessor) {}

//     public draw(mapGebiete: MapGebietRow[]) : void {
//         const { L, map } = this.leafletAccessor;

//         for (const row of mapGebiete) {
//             if (!row.MapGebietGeoJson) continue;
//             if (typeof row.MapGebietGeoJson === "object" && row.MapGebietGeoJson !== null && (row.MapGebietGeoJson as any).type === "FeatureCollection") {
//                 if(row.MapGebietGeoJson.features[0].geometry?.type === "MultiLineString" || row.MapGebietGeoJson.features[0].geometry?.type === "LineString") {
//                     return this.drawLineString(
//                         L, 
//                         map, 
//                         row.MapGebietGeoJson, 
//                         row.FarbcodeRand || '#3388ff',  
//                         row.DickeRand !== undefined && 
//                         row.DickeRand !== null ? parseFloat(row.DickeRand as any) : 1);
//                 }

//                 return this.drawGeoJsonPolygon(
//                     L, 
//                     map, 
//                     row.MapGebietGeoJson, 
//                     row.FarbcodeRand || '#3388ff',  
//                     row.DickeRand !== undefined && row.DickeRand !== null ? parseFloat(row.DickeRand as any) : 1, 
//                     row.FarbcodeFlaeche || '#3388ff', 
//                     row.Opacity || 0.2
//                 );
//             }



//         }
//     }

//     // LineString and MultiLineString
//     private drawLineString(L: any, map: any, geojsonData: GeoJsonRoot, lineColor: string, weight: number) : void {
//         if (!geojsonData) return;

//         const geoJsonLayer = L.geoJSON(geojsonData, {
//             style: { color: lineColor, weight: weight }, 
//         });

//         geoJsonLayer.addTo(map);
//     }


//     // Polygon and MultiPolygon
//     private drawGeoJsonPolygon(L: any, map: any, geojsonData: GeoJsonRoot, borderColor: string, weight: number, fillColor: string, fillOpacity: number) : void {
//         if (!geojsonData) return;

//         const geoJsonLayer = L.geoJSON(geojsonData, {
//             style: { 
//                 color: borderColor || '#3388ff', 
//                 weight: weight || 1, 
//                 fillOpacity: fillOpacity || 0.2,
//                 fillColor: fillColor || '#3388ff'
//             },
//         });

//         geoJsonLayer.addTo(map);
//     }


//}






